export default __webpack_public_path__ + "static/media/twitter.975b3265.svg";